import { Form, FormInstance, Modal } from "antd";
import { MODAL_MASK_COLOR } from "../../../../../../../../../lib/constants";
import { useCallback } from "react";
import "./styles.scss";
import { FormButtons } from "./components/FormButtons";
import { FormContent } from "./components/FormIContent";
import { usePrint } from "./hooks/usePrint";

type PrintTaxModalPros = {
  contractId: string;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const PrintTaxModal = ({
  contractId,
  isOpen,
  setIsOpen,
}: PrintTaxModalPros) => {
  const [form]: FormInstance[] = Form.useForm();

  const close = useCallback(() => {
    setIsOpen(false);
    form.resetFields();
  }, [setIsOpen, form]);

  const { onSave, disabled } = usePrint(contractId, form, close);

  return (
    <Modal
      open={isOpen}
      title="Print Tax 1098 Report"
      width={315}
      onCancel={close}
      centered
      maskStyle={{ backgroundColor: MODAL_MASK_COLOR }}
      wrapClassName="z-1000 position-fixed"
      className="bordered-modal print-tax-modal"
      footer={<FormButtons disabled={disabled} close={close} onSave={onSave} />}
      destroyOnClose
    >
      <FormContent form={form} disabled={disabled} contractId={contractId} />
    </Modal>
  );
};
